module.exports = __webpack_public_path__ + "static/media/tcm.9ef9f7e4.png";